import { render } from "./vehicle-search-hero-component.vue?vue&type=template&id=2da06686"
import script from "./vehicle-search-hero-component.vue?vue&type=script&lang=js"
export * from "./vehicle-search-hero-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__